<script setup>
import { useRouter } from "vue-router";
import { login, captchaImage, getInfo } from "@/api/login.js";
import { onMounted, reactive, ref } from "vue";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import { getToken, setToken, removeToken } from "../../utils/auth";

const router = useRouter();

const getRes = ref();
// 获取验证码
const getImage = () => {
  try {
    captchaImage().then((res) => {
      getRes.value = res;
    });
  } catch (e) {
    console.log(e, "this is e~");
  }
};

const loginForm = reactive({
  username: "",
  password: "",
  code: "",
  uuid: "",
});

const rules = reactive({
  username: [
    {
      required: true,
      message: "请输入登录名",
      trigger: "change",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "change",
    },
  ],
  code: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "change",
    },
  ],
});
const loginFormRef = ref(null);

//重置
const resetForm = (el) => {
  loginFormRef.value.resetFields();
};

// 登录
const goLogin = () => {
  try {
    loginFormRef.value.validate((valid) => {
      if (valid) {
        if (getRes.value.answer != loginForm.code) {
            ElMessage.error("验证码输入有误");
            return;
        }
        let params = {
          ...loginForm,
          code: getRes.value.answer,
          uuid: getRes.value.uuid,
        };
        login(params).then((res) => {
          if (res.code === 200) {
            setToken(res.token);
            Cookies.set("token", res.token);
            ElMessage.success("登录成功");
            getInformation();
            setTimeout(() => {
              router.push("/");
            }, 1500);
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    });
  } catch (e) {
    console.log(e, "this is e~");
  }
};

const goRegister = () => {
  router.push("/register");
};

// 获取个人信息
const getInformation = () => {
  getInfo().then((res) => {
    if (res.code === 200) {
      Cookies.set("user", JSON.stringify(res.user));
      Cookies.set("roles", res.roles);
    }
  });
};

onMounted(() => {
  getImage();
});
</script>
<template>
  <div class="content-layout">
    <img class="content-layout-bg" src="/src/assets/login/bg.png" />
    <div class="cont">
      <div class="login">
        <img src="/src/assets/login/img-left.png" class="l-left" />
        <div class="l-right">
          <span class="l-right-title">
            <img src="/src/assets/login/img-logo-1.png" class="logo"/>
            创业贷信息门户系统
          </span>
          <!-- <img src="/src/assets/login/img-logo.png" class="logo"/> -->
          <el-form
            ref="loginFormRef"
            :model="loginForm"
            :rules="rules"
            label-position="left"
            label-width="100px"
            class="login-class"
          >
            <el-form-item label="登录名" prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入登录名"
              />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-form-item label="验证码" prop="code" class="code_box">
              <el-input
                v-model="loginForm.code"
                style="width: 7.5rem; margin-right: 1rem"
                @keyup.enter="goLogin"
                placeholder="请输入验证码"
              />
              <img
                :src="'data:image/png;base64,' + getRes?.img"
                style="width: 5rem"
                @click="getImage"
              />
            </el-form-item>
          </el-form>
          <div class="btn-list">
            <span class="register-btn" @click="goRegister">注册</span>
            <span class="reset-btn" @click="resetForm(loginFormRef)">重置</span>
            <span class="login-btn" @click="goLogin">登录</span>
          </div>
          <!-- <span class="btn-login" @click="goLogin">使用湖北省统一身份认证平台登录</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content-layout {
  position: relative;
  background-color: rgba(20, 26, 33, 1);
}
.content-layout-bg {
  width: 100%;
}
.cont {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -62%);
}
.login {
  width: 45.62rem;
  height: 28.75rem;
  display: flex;
  text-align: center;
  margin: 0 auto;
}

.l-left {
  width: 22.81rem;
  height: 28.75rem;
}

.logo {
  width: 6.87rem;
  height: 6.87rem;
  margin: 2.18rem 0;
}
.l-right {
  background: #ffffff;
  width: 100%;
  padding: 5rem 0;
}

.l-right span {
  display: block;
  color: #333333;
  font-weight: 500;
  line-height: 1.25rem;
  font-size: 1rem;
  margin-bottom: 0.5rem;

}
.l-right .l-right-title {
  font-size: 1.6rem;
  display: inline-flex;
  align-items: center;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  img {
    width: 3.125rem;
    height: 3.125rem;
    margin: 0 1.25rem 0 0;
  }
}

.l-right .btn-login {
  background-color: rgba(67, 119, 254, 1);
  color: #ffffff;
  width: 18rem;
  margin: 0 auto;
  font-size: 1rem;
  height: 2.75rem;
  line-height: 2.75rem;
  border-radius: 5px;
  color: #ffffff;
}

.l-right span.login-btn {
  background-color: rgba(67, 119, 254, 1);
  width: 6rem;
  height: 2rem;
  line-height: 2rem;
  display: inline-block;
  color: #fff;
  cursor: pointer;
  text-align: center;
  flex-shrink: 0;
}

.l-right span.reset-btn {
  border: 1px solid #e3e6eb;
  width: 6rem;
  height: 2rem;
  line-height: 2rem;
  display: inline-block;
  margin-right: 1.5rem;
  cursor: pointer;
  text-align: center;
  flex-shrink: 0;
}

.l-right span.register-btn {
  background-color: #fba504;
  width: 6rem;
  height: 2rem;
  line-height: 2rem;
  display: inline-block;
  margin-right: 1.5rem;
  cursor: pointer;
  text-align: center;
  flex-shrink: 0;
  color: #fff;
}

.login-class {
  padding: 1.5rem;
}
.btn-list {
  /* width: 13.55rem; */
  text-align: right;
  padding: 0 1.5rem;
  float: right;
  display: flex;
}

.code_box :deep(.el-form-item__content) {
  justify-content: space-between;
  .el-input {
    flex: 1;
  }
}
</style>
